// ReduxHelmet.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

export const ReduxHelmet = ({
  ogTitle = '',
  brandingName = 'SWAG',
  children = null,
}) => {
  const titleTemplate = `%s | ${brandingName}`;

  return (
    <Helmet defaultTitle={ogTitle} titleTemplate={titleTemplate}>
      {children}
    </Helmet>
  );
};

ReduxHelmet.propTypes = {
  children: PropTypes.node,
  ogTitle: PropTypes.string,
  brandingName: PropTypes.string,
};

export default ReduxHelmet;
